import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "@redux/hooks";
import { useToast } from "@shared-kernel/primary/shared/shadcn/ui/use-toast";
import { resetOnboardTeacher } from "@user-management-context/write/application/use-cases/teacher-onboarding/onboard-teacher-reducer";
import { selectTeacherOnboarding } from "@user-management-context/write/application/use-cases/teacher-onboarding/selectors/teacher-onboarding-selectors";

export const useTeacherOnboarding = () => {
  const { toast } = useToast();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { processing } = useAppSelector(selectTeacherOnboarding);

  useEffect(() => {
    if (processing === "success") {
      toast({ description: "Votre profil enseignant est prêt !" });
      dispatch(resetOnboardTeacher());
      navigate("/onboarding");
    } else if (processing === "failed") {
      toast({ description: "Erreur lors de la finalisation de votre profil enseignant", variant: "destructive" });
      dispatch(resetOnboardTeacher());
    }
  }, [processing, toast, dispatch, navigate]);
};
